import { colors, Txt } from '@vst/beam';
import { CheckOutlined } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const MarketingAttributes = ({ attributes }: { attributes: string[] }) => {
  const { t } = useTranslation('NewChangePlan');
  return (
    <div>
      <Txt variant="smallBold">{t('includes')}</Txt>
      <ul className={styles['list']}>
        {attributes.map((attribute) => (
          <li key={attribute} className={styles['listItem']}>
            <CheckOutlined height={20} width={20} color={colors.gray['600']} />
            <Txt variant="bodyLargeRegular" color="regular">
              {attribute}
            </Txt>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MarketingAttributes;
